import { render, staticRenderFns } from "./mainHorizonLayout.vue?vue&type=template&id=e53fbc4e"
import script from "./mainHorizonLayout.vue?vue&type=script&lang=js"
export * from "./mainHorizonLayout.vue?vue&type=script&lang=js"
import style0 from "./mainHorizonLayout.vue?vue&type=style&index=0&id=e53fbc4e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e53fbc4e')) {
      api.createRecord('e53fbc4e', component.options)
    } else {
      api.reload('e53fbc4e', component.options)
    }
    module.hot.accept("./mainHorizonLayout.vue?vue&type=template&id=e53fbc4e", function () {
      api.rerender('e53fbc4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Wrappers/mainHorizonLayout.vue"
export default component.exports